import { TextField, Stack, Typography } from '@mui/material';
import React from 'react';
import VideoAdmin from '../video/VideoAdmin';
import GalleryAdmin from '../gallery/GalleryAdmin';
import Spacer from '../../common/Spacer';

export default function ProjectAdmin(props) {



    return (
    <Stack>
        <Spacer height={40} />
        <Stack direction="row" spacing={2}>
            <Typography variant="h6">Name</Typography>
            <TextField
                variant="outlined"
                fullWidth
                defaultValue={props.name}
                multiline
                onBlur={e => {
                    props.setProperty('name', e.target.value);
                }}
            />
        </Stack>
        <Stack direction="row" spacing={2}>
            <Typography variant="h6">Subtitle</Typography>
            <TextField
                variant="outlined"
                fullWidth
                defaultValue={props.subtitle}
                multiline
                onBlur={e => {
                    props.setProperty('subtitle', e.target.value);
                }}
            />
        </Stack>
        <Stack direction="row" spacing={2}>
            <Typography variant="h6">Type</Typography>
            <TextField
                variant="outlined"
                fullWidth
                defaultValue={props.project_type}
                multiline
                onBlur={e => {
                    props.setProperty('project_type', e.target.value);
                }}
            />
        </Stack>
        <Stack direction="row" spacing={2}>
            <Typography variant="h6">Client</Typography>
            <TextField
                variant="outlined"
                fullWidth
                defaultValue={props.client}
                multiline
                onBlur={e => {
                    props.setProperty('client', e.target.value);
                }}
            />
        </Stack>
        <Stack direction="row" spacing={2}>
            <Typography variant="h6">Years</Typography>
            <TextField
                variant="outlined"
                fullWidth
                defaultValue={props.years}
                multiline
                onBlur={e => {
                    props.setProperty('years', e.target.value);
                }}
            />
        </Stack>
        <Stack direction="row" spacing={2}>
            <Typography variant="h6">Role</Typography>
            <TextField
                variant="outlined"
                fullWidth
                defaultValue={props.role}
                multiline
                onBlur={e => {
                    props.setProperty('role', e.target.value);
                }}
            />
        </Stack>
        <Stack direction="row" spacing={2}>
            <Typography variant="h6">Summary</Typography>
            <TextField
                variant="outlined"
                fullWidth
                defaultValue={props.summary}
                multiline
                onBlur={e => {
                    props.setProperty('summary', e.target.value);
                }}
            />
        </Stack>
        <Stack direction="row" spacing={2}>
            <Typography variant="h6">Contributions</Typography>
            <TextField
                variant="outlined"
                fullWidth
                defaultValue={props.contributions}
                multiline
                onBlur={e => {
                    props.setProperty('contributions', e.target.value);
                }}
            />
        </Stack>
        <Stack direction="row" spacing={2}>
            <Typography variant="h6">Results</Typography>
            <TextField
                variant="outlined"
                fullWidth
                defaultValue={props.results}
                multiline
                onBlur={e => {
                    props.setProperty('results', e.target.value);
                }}
            />
        </Stack>
        <Stack direction="row" spacing={2}>
            <Typography variant="h6">Tools</Typography>
            <TextField
                variant="outlined"
                fullWidth
                defaultValue={props.tools}
                multiline
                onBlur={e => {
                    props.setProperty('tools', e.target.value);
                }}
            />
        </Stack>
        <Stack direction="row" spacing={2}>
            <Typography variant="h6">Links</Typography>
            <TextField
                variant="outlined"
                fullWidth
                defaultValue={props.links}
                multiline
                onBlur={e => {
                    props.setProperty('links', e.target.value);
                }}
            />
        </Stack>
        <Stack direction="row" spacing={2}>
            <Typography variant="h6">Video</Typography>
            <VideoAdmin {...props} />
        </Stack>
        <Stack direction="row" spacing={2}>
            <Typography variant="h6">Gallery</Typography>
            <GalleryAdmin {...props} />
        </Stack>
        <Spacer height={40} />
    </Stack>)
}
